import { useState } from 'react';
import { IconLibrary } from '@product-framework/index';
import { UnSavedChangesDialog, useLocalization } from '@ui-framework/index';
import PermissionButton from '../PermissionButton';
import UpdatePasswordDialog from './UpdatePasswordDialog';

function UserUpdatePasswordDialogWithButton({
  email,
  firstName,
  lastName,
  permissionName,
  formRef = null,
}) {
  if (!permissionName) {
    throw new Error(
      'Please provide permission name for UserUpdatePasswordDialogWithButton',
    );
  }
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const { formatMessage } = useLocalization();

  return (
    <>
      <PermissionButton
        permissionName={permissionName}
        variant="contained"
        color="primary"
        type="button"
        startIcon={<IconLibrary.Password />}
        onClick={() => {
          if (formRef?.current && formRef?.current?.isDirty()) {
            setIsDirty(true);
          } else {
            setPasswordDialog(true);
          }
        }}>
        {formatMessage({
          id: 'USER_RESET_PASSWORD_BUTTON',
          defaultMessage: 'Change Password',
        })}
      </PermissionButton>
      <UnSavedChangesDialog
        open={isDirty}
        onStay={() => setIsDirty(false)}
        onLeave={() => {
          setIsDirty(false);
          formRef?.current?.reset();
          setPasswordDialog(true);
        }}
      />
      {passwordDialog && (
        <UpdatePasswordDialog
          key={passwordDialog ? 'pass1' : 'pass2'}
          open={passwordDialog}
          onClose={() => {
            setPasswordDialog(false);
          }}
          userEmail={email || ''}
          firstName={firstName}
          lastName={lastName}
        />
      )}
    </>
  );
}

export default UserUpdatePasswordDialogWithButton;
